/* eslint-disable */
import React from 'react';
import { useTranslation } from 'react-i18next';

// MUI Icons
import CloudDownloadOutlinedIcon from '@mui/icons-material/CloudDownloadOutlined';

// Custom Components
import TableHeaderButton from './TableHeaderButton';
import { exportTableToExcel } from '@/lib/exportExcel';
import exportTableToShp from '@/lib/exportShp';
import exportTableToDxf from '@/lib/exportDxf';
import { ITableHeaderButtonExportProps } from '@/@types/ui/Table';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

const TableHeaderButtonExport = (props: ITableHeaderButtonExportProps) => {
  const { t } = useTranslation();
  const { dc, rows, records, tableName, exportType, menu, menuTitle, onMenuItemClick, ...rest } = props;

  const handleExport = () => {
    const filteredRecords = [];
    for (let i = 0; i < rows.length; i += 1) {
      const recordIndex = parseInt(rows[i].id, 10);
      filteredRecords.push(records[recordIndex]);
    }

    if (exportType == 'SHP') {
      const fields = dc.getViewFields('exportShp');
      const obj = {
        records: filteredRecords,
        fields,
        filename: tableName || (dc.filename ? dc.filename : ''),
        t,
      };
      exportTableToShp(obj);
    } else if (exportType == 'XLSX') {
      const fields = dc.getViewFields('exportExcel');
      const obj = {
        records: filteredRecords,
        fields,
        filename: tableName || (dc.filename ? dc.filename : ''),
        t,
      };
      exportTableToExcel(obj);
    } else if (exportType == 'DXF') {
      const obj = {
        records: filteredRecords,
        filename: tableName || (dc.filename ? dc.filename : ''),
      };
      exportTableToDxf(obj);
    }
  };

  if (menu) {
    return (
      <MenuItem
        onClick={() => {
          onMenuItemClick?.();
          handleExport();
        }}
        sx={{
          minHeight: { xs: 24, sm: 24, md: 26, lg: 28, xl: 40 },
          px: { xs: 0.25, sm: 0.25, md: 0.5, lg: 0.5, xl: 2 },
          py: { xs: 0, sm: 0, md: 0, lg: 0.25, xl: 1 },
          '& .MuiListItemIcon-root': {
            minWidth: { xs: 22, sm: 22, md: 24, lg: 26, xl: 40 },
            color: 'primary.main',
          },
          '& .MuiSvgIcon-root': {
            fontSize: { xs: 14, sm: 14, md: 16, lg: 18, xl: 24 },
          },
          '& .MuiListItemText-primary': {
            fontSize: {
              xs: '0.6rem',
              sm: '0.6rem',
              md: '0.65rem',
              lg: '0.7rem',
              xl: '0.875rem',
            },
          },
        }}
      >
        <ListItemIcon>
          <CloudDownloadOutlinedIcon />
        </ListItemIcon>
        <ListItemText primary={menuTitle ?? exportType ?? ''} />
      </MenuItem>
    );
  }

  return (
    <TableHeaderButton
      startIcon={<CloudDownloadOutlinedIcon />}
      variant="outlined"
      tooltip={t('buttons.export') ?? ''}
      {...rest}
      onClick={handleExport}
      sx={{ display: { xs: 'none', sm: 'flex' } }}
    >
      {menu ? menuTitle : t('buttons.export') + ` (${exportType})`}
    </TableHeaderButton>
  );
};

export default TableHeaderButtonExport;
